module.exports = __webpack_public_path__ + "static/media/Options.5ba24c64.svg";